<template xmlns="http://www.w3.org/1999/html">
    <div>
         <h4>Choose from the list below and upload your photo.</h4><br>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>
        <p>Please upload a document that includes your current home address.</p>
        <p>This document must be dated within the last 3 months.</p>
        <h4>Remember, the photo of your document must be:</h4><br>
        <ul>
            <li>Clear and in focus (so that the information on your document is readable)</li>
            <li>In colour</li>
            <li>Unaltered by computer software in any way</li>
        </ul><br>
          <img src="https://images.ctfassets.net/2tjc93jinw29/6FCAtxJ5tIXbCuqAgVWc49/09b7d20568d8fa9d3e5e0a7294a771f9/selfie2.jpg?h=600" alt="" class="responsive">


        <InputRadioGroup
            name="proof_address"
            :required="checkIsRequired('proof_address')"
            :error="formRef.errors.get('proof_address')"
            v-model="formRef.proof_address"
            :options="getField('proof_address')['options']"
        >
            <template v-slot:question>
                {{ getField("proof_address").question }}
            </template>
        </InputRadioGroup>

        <InputFile
            @input="handleFileInput"
            :error="formRef.errors.get('file')"
            accept="image/jpeg,image/png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
        />
    </div>
</template>

<script setup>
import InputRadioGroup from "../Form/InputRadioGroup.vue";
import InputFile from "../Form/InputFile.vue";
import Form from "../../../js/Form";
import { isRequired } from "../Application/formHelper";
import { ref, markRaw } from "vue";

const emit = defineEmits('buttonDisabled')

const props = defineProps({
    step: Object,
    fields: Object,
    formData: Object
})

const whichDocumentDefault = { Which_document: "" }

let formRef = markRaw(ref(new Form({
    ...whichDocumentDefault,
    file: null
}, {...whichDocumentDefault, ...props.formData})))

const getField = (fieldName) => {
   return props.fields[fieldName];
}

const checkIsRequired = (fieldName) => {
   var fieldData = getField(fieldName);
   return isRequired(fieldData, formRef.value);
}

function handleFileInput(e) {
    formRef.value.file = e;
    emit("buttonDisabled", false)
}

defineExpose({
    formRef
})
</script>

<style scoped>
.responsive {
  width: 100%;
  height: auto;
  padding-left: 10%;
  margin-bottom: 10%;
}
</style>